// extracted by mini-css-extract-plugin
module.exports = {"characteristics_section":"Characteristics_characteristics_section__hpe2g","characteristics_mobile_image":"Characteristics_characteristics_mobile_image__MfOCj"};